import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import { StyledStepsWrapper } from './ReplenishmentTooltipModalStyles';
import { ReplenishmentTooltipModalStep } from './ReplenishmentTooltipModalStep';
import {
    stepOneIcon,
    stepTwoIcon,
    stepThreeIcon,
    replenishmentStepWrapperModalClass,
    translationsList
} from './utils';

export const ReplenishmentTooltipModalSteps = observer(() => {
    const {
        stepOneSchedule,
        selectYourDeliveryScheduleAndAddProduct,
        stepTwoCheckout,
        checkoutToCompleteYourOrder,
        stepThreeDelivery,
        freeDeliveryPlusDiscount
    } = useTranslation(translationsList);

    const stepsData = [
        {
            icon: stepOneIcon,
            title: stepOneSchedule,
            description: selectYourDeliveryScheduleAndAddProduct
        },
        {
            icon: stepTwoIcon,
            title: stepTwoCheckout,
            description: checkoutToCompleteYourOrder
        },
        {
            icon: stepThreeIcon,
            title: stepThreeDelivery,
            description: freeDeliveryPlusDiscount
        }
    ];

    return (
        <StyledStepsWrapper className={replenishmentStepWrapperModalClass}>
            {stepsData.map(({ icon, title, description }) => (
                <ReplenishmentTooltipModalStep
                    key={title}
                    icon={icon}
                    title={title}
                    description={description}
                />
            ))}
        </StyledStepsWrapper>
    );
});
